/* family-support page */
import { createApp } from 'vue';
import { Fancybox } from '@fancyapps/ui';
import vueUIInitiator from './modules/vue-ui-initiator';
import Switcher from './vue-components/pages/Switcher';
import AccordionItem from './vue-components/pages/AccordionItem';

vueUIInitiator('js-switcher', Switcher, 'switcher');

// родительские компоненты аккордеона
const accParent = document.getElementById('accordion'); // аакордион

if (accParent) {
    createApp({
        components: {
            AccordionItem,
        },
        data() {
            return {
                isMobile: window.innerWidth < 768,
                isShowedMore: false
            };
        },
        methods: {
            setActiveAcc(name) {
                Object.keys(this.$refs).forEach((item) => {
                    this.$refs[item].activated = false;
                });

                const sameName = this.curActiveRef === name;
                this.curActiveRef = sameName ? null : name;

                if (!sameName) {
                    this.$refs[name].activated = true;
                }
            }
        }
    }).mount(accParent);
}

document.addEventListener('DOMContentLoaded', () => {
    const isMobile = window.innerWidth < 1123;

    Fancybox.bind('.js-fancybox', {
        mainClass: 'fs-modal__parent',
        autoFocus: false,
        dragToClose: isMobile
    });
});
